<script lang="ts">
  import { onMount } from "svelte";
  import cfg from "$lib/config/config";

  import { account } from "$lib/stores/account";
  import {
    getVoyadoContactId,
    voyadoIdentifyCustomer,
  } from "$lib/utils/voyado";

  onMount(() => {
    const contactId = getVoyadoContactId();
    const email = $account?.email;

    if (!contactId && email) {
      voyadoIdentifyCustomer(email);
    }
  });
</script>

<svelte:head>
  {#if cfg.VOYADO_TRACKING_ENABLED}
    {#if cfg.VOYADO_ENV === "staging"}
      <script>
        (function (i, s, o, g, r, a, m) {
          i["VoyadoAnalyticsObject"] = r;
          (i[r] =
            i[r] ||
            function () {
              (i[r].q = i[r].q || []).push(arguments);
            }),
            (i[r].l = 1 * new Date());
          (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
          a.async = 1;
          a.src = g;
          m.parentNode.insertBefore(a, m);
        })(
          window,
          document,
          "script",
          `https://assets.voyado.com/jsfiles/analytics_0.1.7.staging.min.js`,
          "va",
        );
        va("setTenant", "belstaff");
      </script>
    {:else}
      <script>
        (function (i, s, o, g, r, a, m) {
          i["VoyadoAnalyticsObject"] = r;
          (i[r] =
            i[r] ||
            function () {
              (i[r].q = i[r].q || []).push(arguments);
            }),
            (i[r].l = 1 * new Date());
          (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
          a.async = 1;
          a.src = g;
          m.parentNode.insertBefore(a, m);
        })(
          window,
          document,
          "script",
          `https://assets.voyado.com/jsfiles/analytics_0.1.7.min.js`,
          "va",
        );
        va("setTenant", "belstaff");
      </script>
    {/if}
  {/if}
</svelte:head>
